import React, { Component } from "react";
import PropTypes from "prop-types";
import { connectPagination } from "react-instantsearch/connectors";
import ReactPaginate from "react-paginate";
import { productsScroll } from "../../utils/PageScrollUtils";
import lodashGet from "lodash.get";
import "./Pagination.css";

const maxPaginationItems = {
  small: 3,
  medium: 11,
  large: 11
};

class Pagination extends Component {
  changePage = index => {
    this.props.refine(index);
    productsScroll();
  };

  render() {
    const { nbPages } = this.props;
    if (nbPages <= 1) {
      return null;
    }

    const pagesArray = [];
    for (let i = 1; i <= nbPages; i++) {
      pagesArray.push(i);
    }

    return (
      <div className="pagination-wrapper" data-ref="pagination-wrapper">
        <div className={"pagination-list"}>
          <ReactPaginate
            pageCount={nbPages}
            // minus one as ReactPaginate starts with page 0 and we start with page 1
            pageRangeDisplayed={
              window && window.innerWidth < 640
                ? maxPaginationItems.small
                : maxPaginationItems.medium
            }
            marginPagesDisplayed={1}
            onPageChange={({ selected }) =>
              // plus one as ReactPaginate starts with page 0 and we start with page 1
              this.changePage(selected + 1)
            }
            pageClassName="page-list-item"
            nextClassName="next-button"
            previousClassName="prev-button"
            breakClassName="ellipsis"
            activeClassName="active-page"
            pageLinkClassName="page-link"
            previousLabel="Prev"
            disabledClassName="disabled"
          />
        </div>
      </div>
    );
  }
}

Pagination.defaultProps = {
  currentRefinement: 1,
  document: lodashGet(global, "document")
};

Pagination.propTypes = {
  refine: PropTypes.func,
  nbPages: PropTypes.number,
  currentRefinement: PropTypes.number,
  searchContext: PropTypes.string,
  view: PropTypes.string,
  seoPath: PropTypes.string,
  setPageNumberToUrl: PropTypes.func,
  triggerAnalyticsEvent: PropTypes.func
};

export default connectPagination(Pagination);

export { Pagination };
